




























import Vue from 'vue';
import FilterBrand from '@/components/FilterBrand.vue';
import FilterFileType from '@/components/FilterFileType.vue';
import FilterCategory from '@/components/FilterCategory.vue';
import FilterAdvanced from '@/components/FilterAdvanced.vue';
import * as api from '@/api';

/**
 * 通过api.getProductFilter()获取全部筛选项，除此之外就是一个纯组件
 */
export default Vue.extend({
    name: 'ProductFilter',
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    components: {
        FilterBrand,
        FilterFileType,
        FilterCategory,
        FilterAdvanced,
    },
    data() {
        return {
            advancedFilter: false,
            curShowFilter: '' as '' | 'brand' | 'category' | 'file',
            filterBrandData: [] as api.FilterBrand[],
            filterBrandSelected: [] as api.FilterBrand[],
            filterCategoryData: [] as api.FilterCategory[],
            filterCategorySelected: [] as api.FilterCategory[],
            filterFileTypeData: [] as api.FilterFileType[],
            filterFileTypeSelected: [] as api.FilterFileType[],
            filterAdvancedData: [] as api.FilterAdvanced[],
            filterAdvancedSelected: [] as any[],
            categorySum: 0 as number,
        };
    },
    computed: {
        filterSelectedSimple(): any {
            return {
                brands: this.filterBrandSelected,
                categories: this.filterCategorySelected,
                fileTypes: this.filterFileTypeSelected,
            };
        },
        filterData(): any {
            return {
                brands: this.filterBrandSelected,
                categories: this.filterCategorySelected,
                fileTypes: this.filterFileTypeSelected,
                advanced: this.filterAdvancedSelected,
            };
        },
        searchKeyword(): string {
            return this.$store.state.searchKeyword;
        },
    },
    watch: {
        filterData(val) {
            this.$emit('input', val);
        },
        filterBrandSelected() {
            this.fetchFilterByBrand();
        },
        filterCategorySelected() {
            this.fetchFilterByCategory();
        },
        filterFileTypeSelected() {
            this.fetchFilterByFileType();
        },
        filterAdvancedSelected() {
            this.fetchFilter();
        },
        searchKeyword() {
            this.fetchFilter();
        },
        async filterSelectedSimple(selected: any) {
            if (selected.brands.length > 0 || selected.categories.length > 0 || selected.fileTypes.length > 0) {
                await this.fetchFilterAdvanced();
            } else {
                this.filterAdvancedData = [];
            }
        },
        filterCategoryData(data) {
            this.categorySum = 0;
            this.getCategorySum(data);
        },
    },
    async created() {
        await this.fetchFilter();
    },
    methods: {
        getCategorySum(data) {
            data.forEach((e) => {
                if (e.children.length > 0) {
                    this.getCategorySum(e.children);
                } else {
                    this.categorySum += 1;
                }
            });
        },
        async fetchFilter() {
            const res = await api.getProductFilter({
                keyword: this.searchKeyword,
                brandIds: this.filterBrandSelected.map((b) => b.id),
                categoryIds: this.filterCategorySelected.map((c) => c.id),
                fileTypeNames: this.filterFileTypeSelected.map((f) => f.name),
                highFilterProperties: this.filterAdvancedSelected,
            });
            if (!api.error(res)) {
                this.filterBrandData = res.data.brands;
                this.filterCategoryData = res.data.categories;
                this.filterFileTypeData = res.data.fileTypes;
            }
        },
        async fetchFilterByBrand() {
            const res = await api.getProductFilter({
                keyword: this.searchKeyword,
                brandIds: this.filterBrandSelected.map((b) => b.id),
                categoryIds: this.filterCategorySelected.map((c) => c.id),
                fileTypeNames: this.filterFileTypeSelected.map((f) => f.name),
                highFilterProperties: this.filterAdvancedSelected,
            });
            if (!api.error(res)) {
                // this.filterBrandData = res.data.brands;
                this.filterCategoryData = res.data.categories;
                this.filterFileTypeData = res.data.fileTypes;
            }
        },
        async fetchFilterByCategory() {
            const res = await api.getProductFilter({
                keyword: this.searchKeyword,
                brandIds: this.filterBrandSelected.map((b) => b.id),
                categoryIds: this.filterCategorySelected.map((c) => c.id),
                fileTypeNames: this.filterFileTypeSelected.map((f) => f.name),
                highFilterProperties: this.filterAdvancedSelected,
            });
            if (!api.error(res)) {
                this.filterBrandData = res.data.brands;
                // this.filterCategoryData = res.data.categories;
                this.filterFileTypeData = res.data.fileTypes;
            }
        },
        async fetchFilterByFileType() {
            const res = await api.getProductFilter({
                keyword: this.searchKeyword,
                brandIds: this.filterBrandSelected.map((b) => b.id),
                categoryIds: this.filterCategorySelected.map((c) => c.id),
                fileTypeNames: this.filterFileTypeSelected.map((f) => f.name),
                highFilterProperties: this.filterAdvancedSelected,
            });
            if (!api.error(res)) {
                this.filterBrandData = res.data.brands;
                this.filterCategoryData = res.data.categories;
                // this.filterFileTypeData = res.data.fileTypes;
            }
        },
        async fetchFilterAdvanced() {
            const res = await api.getProductFilterAdvanced({
                productName: this.$store.state.searchKeyword,
                brandIds: this.filterBrandSelected.map((b) => b.id),
                categoryIds: this.filterCategorySelected.map((c) => c.id),
                fileTypeNames: this.filterFileTypeSelected.map((f) => f.name),
            });
            if (!api.error(res)) {
                this.filterAdvancedData = res.data;
            }
        },
        clearSelected() {
            this.filterBrandSelected = [];
            this.filterCategorySelected = [];
            this.filterFileTypeSelected = [];
            this.filterAdvancedSelected = [];
        },
        resetAdvanced() {
            (this.$refs.advanced as any).reset();
        },
    },
});
